<template>
	<svg
		:alt="alt"
		xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 16 18">
		<path fill="#0D74B5" d="M850.833333,164 C851.059028,164 851.25434,164.079167 851.419271,164.2375 L854.752604,167.4375 C854.917535,167.595833 855,167.783333 855,168 C855,168.216667 854.917535,168.404167 854.752604,168.5625 L851.419271,171.7625 C851.25434,171.920833 851.059028,172 850.833333,172 C850.607639,172 850.412326,171.920833 850.247396,171.7625 C850.082465,171.604167 850,171.416667 850,171.2 L850,169 L850,169 C846.962434,169 844.5,171.462434 844.5,174.5 C844.5,177.537566 846.962434,180 850,180 C853.037566,180 855.5,177.537566 855.5,174.5 C855.5,173.947715 855.947715,173.5 856.5,173.5 C857.052285,173.5 857.5,173.947715 857.5,174.5 C857.5,178.642136 854.142136,182 850,182 C845.857864,182 842.5,178.642136 842.5,174.5 C842.5,170.357864 845.857864,167 850,167 L850,164.8 C850,164.583333 850.082465,164.395833 850.247396,164.2375 C850.412326,164.079167 850.607639,164 850.833333,164 Z" transform="matrix(-1 0 0 1 858 -164)"/>
	</svg>
</template>

<script>
export default {
	props: {
		alt: String
	}
};
</script>
